module.exports = __webpack_public_path__ + "front/img/logo-5.653c245b.png";